import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function MbaleBaselineHIVOS() {
  return (
    <div className="art-page">
      <SEO
        title="Baseline Study — Social, Cultural and Economic Conditions in Rural Mbale (HIVOS)"
        description="CIRCODU conducted a baseline study for HIVOS Foundation in rural Mbale, examining social, cultural, and economic conditions affecting clean fuel adoption."
        keywords="HIVOS, Mbale, baseline study, social conditions, cultural conditions, economic conditions, clean fuels, indoor air quality, CIRCODU, Clean Air Zone Uganda, rural energy access, household energy use, community attitudes, enabling factors, limiting factors, clean cooking interventions Uganda, HIVOS clean air initiative Uganda"
        url="/Baseline-Study-Social-Cultural-and-Economic-Conditions-in-Rural-Mbale-HIVOS-Clean-Air-Zone-Uganda"
        datePublished="2018-12-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Baseline Study — Social, Cultural and Economic Conditions in Rural
              Mbale (HIVOS)
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              December 01, 2018
            </div>
            <h1 className="art-title">
              Baseline Study — Social, Cultural and Economic Conditions in Rural
              Mbale (HIVOS Clean Air Zone Uganda)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In late 2018, CIRCODU conducted a baseline study for{" "}
                <strong>HIVOS Foundation</strong> in rural Mbale, a densely
                populated agricultural district on Uganda's eastern border with
                Kenya at the foot of Mt. Elgon. The study focused on the{" "}
                <strong>Clean Air Zone Uganda</strong> initiative, examining
                baseline conditions in rural communities where HIVOS was
                planning to promote clean fuel adoption.
              </p>
              <p>
                HIVOS is a Dutch international development organisation with a
                strong focus on clean energy access and human dignity. Its Clean
                Air Zone initiative recognised that addressing indoor air
                pollution from cooking is not merely a technical challenge but a
                deeply social one — requiring a nuanced understanding of
                community knowledge, attitudes, and lived realities before any
                intervention can hope to succeed.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                The study was designed to capture household and community-level
                conditions across four dimensions:
              </p>
              <ol>
                <li>
                  The physical household and community setting, including
                  cooking infrastructure, fuel types, and stove technologies in
                  use.
                </li>
                <li>
                  Knowledge, attitudes, and perceptions regarding clean fuels
                  and indoor air quality.
                </li>
                <li>
                  Enabling factors likely to facilitate household adoption of
                  clean cooking technologies.
                </li>
                <li>
                  Limiting factors — social, economic, and cultural — that might
                  inhibit behaviour change.
                </li>
              </ol>
              <p>
                CIRCODU conducted household surveys across the study communities
                and key informant interviews with community leaders, health
                workers, and local energy sector actors. The baseline gave HIVOS
                the nuanced, context-specific starting point it needed to design
                effective and culturally appropriate interventions.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's baseline research services,
                contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
